import { showToast } from '.'
import history from './history.js'

const handleError = () => {
  showToast("warning", "Alerta", "Não foi possivel carregar os dados. Verifique sua conexão e tente novamente.");
  history.goBack()
}

export default handleError